import type { PurchaseChainOption } from 'src/utils/purchaseChains';

/**
 * Which network the payment screens describe: the one the money actually went to.
 *
 * The list of offered networks is live — `GET /buyer/chains` refetches while the modal sits in
 * "verifying", and a chain that disappears from the answer or simply comes back in another order
 * changes which option the selection falls back to. Before a payment that is harmless. After one it
 * is not: the explorer link and the token symbol would start describing a network the money never
 * touched, sending the buyer to look for their transaction on the wrong chain.
 *
 * So once a transfer is confirmed the network is frozen (`paid`) and this rule refuses to leave it,
 * whatever the live selection does afterwards.
 */
export const settledChain = (
  paid: PurchaseChainOption | null,
  live: PurchaseChainOption | undefined
): PurchaseChainOption | null => paid ?? live ?? null;
